var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"seven"},[_c('h1',{class:_vm.$vuetify.breakpoint.xs ? 'text-h6' : ''},[_vm._v(" "+_vm._s(_vm.$t(_vm.title))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }